<template>
  <div>交通事件上报</div>
</template>
<script setup>

</script>
<style scoped lang="less">

</style>